import React from 'react'
import { useTranslation } from 'react-i18next'
import { FaCheck } from 'react-icons/fa'
import styled from 'styled-components'
import { WHEN_NARROW } from '../../layout'

export const NeedsYouEmptyState: React.FC = () => {
  const [t] = useTranslation()

  return (
    <EmptyState>
      <Headline>
        <HeadlineIcon>
          <FaCheck size={14} aria-hidden />
        </HeadlineIcon>
        <HeadlineText>
          <HeadlineTitle>{t('dashboard.emptyAlert.title')}</HeadlineTitle>
          <HeadlineSubtitle>{t('dashboard.emptyAlert.description')}</HeadlineSubtitle>
        </HeadlineText>
      </Headline>
      <Spacer />
      <FooterNote>
        <StatusDot />
        <FooterText>{t('dashboard.emptyAlert.checkedNow')}</FooterText>
      </FooterNote>
    </EmptyState>
  )
}

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  overflow: hidden;
  border-radius: 0 0 ${({ theme }) => theme.borderRadius.md}rem
    ${({ theme }) => theme.borderRadius.md}rem;
`

const Headline = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.md}rem;
  padding: ${({ theme }) => theme.spacing.lg}rem ${({ theme }) => theme.spacing.lg}rem
    ${({ theme }) => theme.spacing.md}rem;

  ${WHEN_NARROW} {
    padding: ${({ theme }) => theme.spacing.md}rem;
  }
`

const HeadlineIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2.125rem;
  height: 2.125rem;
  border-radius: 0.6875rem;
  background: ${({ theme }) => theme.dashboard.positiveTint};
  color: ${({ theme }) => theme.dashboard.positive};
`

const HeadlineText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xxxs}rem;
  min-width: 0;
`

const HeadlineTitle = styled.span`
  font-size: ${({ theme }) => theme.fontSize.md}rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.menuBg};
`

const HeadlineSubtitle = styled.span`
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  color: ${({ theme }) => theme.colors.iconGray};
`

const Spacer = styled.div`
  flex: 1;
`

const FooterNote = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}rem;
  padding: ${({ theme }) => theme.spacing.md}rem ${({ theme }) => theme.spacing.lg}rem;
  border-top: 1px solid ${({ theme }) => theme.colors.neutralGray};
  background: ${({ theme }) => theme.colors.defaultHover};

  ${WHEN_NARROW} {
    padding: ${({ theme }) => theme.spacing.md}rem;
  }
`

const StatusDot = styled.span`
  flex-shrink: 0;
  width: 0.4375rem;
  height: 0.4375rem;
  border-radius: 50%;
  background: ${({ theme }) => theme.dashboard.positive};
`

const FooterText = styled.span`
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  color: ${({ theme }) => theme.colors.iconGray};
`
